import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Sorry, page not found</h1>
              <h2>404 error</h2>
        </div>
    );
};

export default NotFound;